import { ReactNode } from 'react';
import { LoadingPlaceholder } from '@/common/components/LoadingPlaceholder/LoadingPlaceholder';
import { useAuth } from '@/common/contexts/authentication/AuthProvider';
import { useFeatures } from '@/common/integrations/feature-flag/feature-flag.hooks';
import { useGetFeatures } from '@/common/integrations/menhir/employee/features/features.hooks';

export const AppInitProvider = ({
  children,
  loadingFallback = <LoadingPlaceholder />,
}: TAppInitProviderProps) => {
  const { isInitializing } = useAppInitActions();

  if (isInitializing) {
    return <>{loadingFallback}</>;
  }

  return <>{children}</>;
};

export interface TAppInitProviderProps {
  loadingFallback?: ReactNode;
  children: ReactNode;
}

export const useAppInitActions = () => {
  const { user } = useAuth();
  const { isInitialLoading: oldFeatureFlagsInitialLoading } = useGetFeatures({
    enabled: !!user,
  });
  const { isInitialLoading: featureFlagsInitialLoading } = useFeatures({
    enabled: !!user,
  });

  return {
    isInitializing: Boolean(
      user && (oldFeatureFlagsInitialLoading || featureFlagsInitialLoading)
    ),
  };
};
